import {
    Box,
    IconButton,
    InputAdornment,
    OutlinedInput,
    Typography,
} from '@mui/material'
import { ReactElement, useEffect, useRef, useState } from 'react'
import { AddRounded, SearchOutlined } from '@mui/icons-material'
import TruncatedText from './TruncatedText'
import { useTranslation } from 'react-i18next'

interface SearchInputProps {
    id: string
    label: string
    value: any
    placeholder?: string
    onChange: any
    onSelect: any
    searchedList: any[]
    disabled?: boolean
    displayName?: string
    list_Height?: string
    isAddNew?: boolean
    onSelectAddNew?: () => void
}

const SearchInput = (props: SearchInputProps): ReactElement => {
    const {
        id,
        label = '',
        value = null,
        placeholder,
        onChange,
        onSelect,
        searchedList = [],
        disabled,
        displayName,
        list_Height,
        isAddNew,
        onSelectAddNew = () => {},
    } = props
    const { t } = useTranslation()

    const [val, setVal] = useState(value)
    const [open, setOpen] = useState(false)
    const dropdownRef = useRef(null)
    const inputRef = useRef<HTMLInputElement>(null)

    const handleClickOutside = (event: any) => {
        const container = dropdownRef.current ?? document.body // Fallback to body
        if (container.contains(event.target)) {
            // nothing
        } else {
            setOpen(false)
            setVal(value)
        }
    }

    useEffect(() => {
        setVal(value)
        document.addEventListener('mousedown', handleClickOutside)
        return () =>
            document.removeEventListener('mousedown', handleClickOutside)
    }, [value])

    const onChangeText = (id: string, value: string) => {
        setOpen(true)
        setVal(value)
        onChange(id, value)
    }

    const onSelectText = (i: any) => {
        onSelect(i)
        setOpen(false)
        if (i === '') {
            setVal('')
        }
    }

    const onclickSearchIcon = () => {
        if (inputRef.current) {
            inputRef.current.focus()
        }
    }

    const onFocusSearch = () => {
        setOpen(true)
    }

    const onClickAddNew = () => {
        setOpen(false)
        inputRef.current?.blur()
        onSelectAddNew()
    }
    return (
        <Box
            sx={{
                width: '100%',
                position: 'relative',
            }}
            ref={dropdownRef}
        >
            <OutlinedInput
                size="small"
                label={label}
                id={id}
                value={val}
                ref={inputRef}
                onChange={(e) => onChangeText(id, e.target.value)}
                type="text"
                required={false}
                placeholder={placeholder ? placeholder : t('search')}
                inputProps={{
                    style: {
                        fontSize: 14,
                        opacity: val !== '' && val !== null ? '1' : '0.4',
                    },
                    autoComplete: 'off',
                }}
                endAdornment={
                    <InputAdornment position="end" sx={{ width: '24px' }}>
                        <IconButton disabled={disabled}>
                            <SearchOutlined
                                id={id + '-search-icon'}
                                onClick={() => onclickSearchIcon()}
                            />
                        </IconButton>
                    </InputAdornment>
                }
                disabled={disabled}
                sx={{
                    opacity: disabled ? '0.3' : '1',
                    width: '100%',
                }}
                onFocus={onFocusSearch}
            />
            <Box
                sx={{
                    position: 'absolute',
                    boxShadow: '0px 0px 5px 0px #959292',
                    width: '100%',
                    marginTop: '5px',
                    maxHeight: list_Height ? list_Height : '250px',
                    overflowY: 'auto',
                    borderRadius: '3px',
                    zIndex: '10100',
                    background: '#fff',
                    marginLeft: '2px',
                }}
            >
                {open ? (
                    <>
                        {isAddNew && (
                            <Box
                                sx={{
                                    padding: '5px 10px',
                                    '&:hover': {
                                        background: '#00000010',
                                    },
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                id={id + '-add-new'}
                                onClick={onClickAddNew}
                            >
                                <AddRounded
                                    color={'primary'}
                                    // sx={{
                                    //     background: '#fff',
                                    //     borderRadius: '50%',
                                    //     boxShadow: '1px 1px 4px 0px #00000080',
                                    // }}
                                />
                                <Box
                                    sx={{
                                        marginLeft: '5px',
                                        paddingTop: '2px',
                                    }}
                                >
                                    <Typography fontWeight="600">
                                        {t('addNew')}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                        {searchedList.map((i: any, index: number) => (
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '5px 10px',
                                    '&:hover': {
                                        background: '#00000010',
                                        '& > .row-icon': {
                                            display: 'flex',
                                        },
                                    },
                                }}
                                onClick={() => onSelectText(i)}
                                key={index}
                                id={id + '-option-' + index}
                            >
                                <Box
                                    sx={{
                                        width: '100%',
                                    }}
                                >
                                    <TruncatedText text={null}>
                                        {displayName
                                            ? i[displayName]
                                            : i.displayName}
                                    </TruncatedText>
                                </Box>
                            </Box>
                        ))}
                    </>
                ) : (
                    <></>
                )}
            </Box>
        </Box>
    )
}

export default SearchInput
